import { RatingItem } from '../server/rating/list/get'
import React from 'react'
import Card from './Card'
import classNames from 'classnames'
import Avatar from './Avatar'
import Chip from './Chip'
import Balls from './Balls'
import { Link } from 'react-router-dom'

interface Props extends RatingItem {
  className?: string
  children?: React.ReactNode
}

const RatingCard: React.FC<Props> = ({
  className,
  id,
  name,
  info,
  avatarUrl,
  position,
  balls,
  children
}) => {
  return (
    <Card className={classNames('rating-card', className)}>
      <div className={'rating-card__position'}>
        <Chip>{position.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}</Chip>
      </div>
      <div className={'rating-card__content'}>
        <div className={'rating-card__info'}>
          <Avatar size={'sm'} url={avatarUrl}></Avatar>
          <Link to={'/participant/' + id} className={'rating-card__name text-body-bold'}>{name}</Link>
        </div>

        {info && info.length ? (
          <div className={'row row-gap-8'}>
            {info.map((item) => (
              <Chip className={'text-secondary-color'} key={item}>
                {item}
              </Chip>
            ))}
          </div>
        ) : null}
      </div>
      {balls && (
        <Balls
          icon="/i/svg/rating.svg"
          className={'rating-card__balls text-body-small text-secondary-color'}
          balls={balls}
        ></Balls>
      )}
      {children}
    </Card>
  )
}

export default RatingCard
